import type { TemplateView } from "src/components/template/types";

const transformTemplateView = (templateView: TemplateView): TemplateView => {
    return {
        id: templateView.id,
        teamId: templateView.teamId,
        isDefault: templateView.isDefault,
        dashboards: templateView.dashboards.map((dashboard) => ({
            id: dashboard.id,
            title: dashboard.title,
            urlHandle: dashboard.urlHandle,
            defaultDateRange: dashboard.defaultDateRange,
            templates: dashboard.templates.map((template) => ({
                id: template.id,
                title: template.title,
                knowledgeBaseName: template.knowledgeBaseName,
                dependencies: template.dependencies,
                configurationAction: template.configurationAction,
                queryVariablesSetter: template.queryVariablesSetter,
                propertySetter: template.propertySetter,
                rows: template.rows.map((row) => ({
                    singleCard: row.singleCard,
                    items: row.items,
                })),
            })),
        })),
    };
};

export default transformTemplateView;
